// tslint:disable-next-line:eofline
export * from './comp-branch-location-entity-link-container.model';
